import { Badge } from 'avo-ui'
import { Link } from 'react-router-dom'
import { formatDateMoment, setNumberWithPoint } from 'utils/utils'
import icImageDefault from 'assets/images/ic-image-x.svg'

export const TABLE_BRAND = {
    name: 'Brand',
    column: [
        {
            name: 'Brand',
            key: 'brand',
            render: ({ item }) => (
                <Link
                    to={`/product/brand-list/update-brand?brandId=${item?.id}`}
                    className={'flex flex-row gap-3 items-center'}
                >
                    <img className={'w-7 h-7'} src={item?.image_url || icImageDefault} alt={item?.name} />
                    <div className={'capitalize font-medium text-blue-90 hover:font-bold hover:underline'}>
                        {item?.name}
                    </div>
                </Link>
            ),
        },
        {
            name: 'Total Produk',
            key: 'product_count',
            render: ({ value }) => <div>{setNumberWithPoint(value)}</div>,
        },
        {
            name: 'Last Modified',
            key: 'updated_at',
            render: ({ value }) => <div>{formatDateMoment(value, 'DD/MM/YYYY HH:mm')}</div>,
        },
        {
            name: 'Status',
            key: 'status',
            render: ({ value }) => <Badge title={value} type={value} />,
        },
    ],
}

export const INITIAL_DATA_FILTER = {
    search: '',
    page: 1,
    limit: 20,
    order_by: 'created_at',
    order_type: 'desc',
}

export const SORT_BRAND = [
    {
        label: 'Sort By Name Desc',
        key: 'name-desc',
        name: 'sort-product',
    },
    {
        label: 'Sort By Name Asc',
        key: 'name-asc',
        name: 'sort-product',
    },
    {
        label: 'Sort By Created At Desc',
        key: 'created_at-desc',
        name: 'sort-product',
    },
    {
        label: 'Sort By Created At Asc',
        key: 'created_at-asc',
        name: 'sort-product',
    },
]
